import { Button } from "@/components/ui/baseUi/button"
import { GenderInput } from "@/modules/auth/components/genderInput"
import type { GenderCategory } from "@/modules/profile/publicProfile/gateway/publicProfileDto"
import { type SimpleFormik } from "@/typings/formik"
import { type ProfileRegisterFormikType, type ProfileRegisterInputKey } from "@modules/auth/profileRegisterFormikTypes"
import { word } from "@modules/core/utils/i18n"
import { ArrowLeft } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"

export type RegisterFormTwoPageProps = {
  handleSubmit: () => void
  onPrevious: () => void
  formik: SimpleFormik<ProfileRegisterFormikType, ProfileRegisterInputKey>
  getFormErrorMessage: (name: ProfileRegisterInputKey, errorMessage?: string) => React.JSX.Element | undefined
  disabled: boolean
  className?: string
} & React.ComponentProps<"div">

export function RegisterFormTwoPage({
  handleSubmit,
  onPrevious,
  formik,
  disabled,
  className,
}: RegisterFormTwoPageProps) {
  const handleSelectGender = (gender: "MALE" | "FEMALE") => {
    void formik.setFieldValue("genderCategory", gender)
  }

  return (
    <div className={cn("flex grow flex-col justify-between gap-4", className)}>
      <div className="mb-2 flex grow flex-col justify-between gap-3">
        <Button variant="ghost" size="xs" onClick={onPrevious} className="w-fit justify-start">
          <ArrowLeft />
          {word("global.previous")}
        </Button>

        <Text fontStyle="TM">2/4</Text>
        <Text fontStyle="TM">{word("auth.signup.form.page.2.title")}</Text>
        <Text fontStyle="BS" color="--neutral-700">
          {word("auth.signup.form.page.2.description")}
        </Text>

        <GenderInput
          handleSelectGender={handleSelectGender}
          selectedGender={formik.getFieldProps("genderCategory").value as GenderCategory}
        />
      </div>

      <Button type="button" size="lg" variant="primary" onClick={handleSubmit} disabled={disabled}>
        {word("global.next")}
      </Button>
    </div>
  )
}
